import { Form, FormItemProps } from 'antd';
import { CssColors } from 'src/styles/CssVariables';
import styled from 'styled-components';

export const FormItem = ({ children, ...props }: FormItemProps) => {
    return (
        <StyledFormItem colon={false} labelCol={{ span: 24 }} {...props}>
            {children}
        </StyledFormItem>
    );
};

const StyledFormItem = styled(Form.Item)`
    .ant-input-number-focused,
    .ant-input-number:hover,
    .ant-input-number:focus,
    .ant-input:hover,
    .ant-input:focus {
        border-color: ${CssColors.black} !important;
    }

    .ant-input-number:focus,
    .ant-input-number-focused,
    .ant-input:focus {
        box-shadow: 0 0 0 2px rgba(29, 29, 31, 0.2) !important;
    }

    .ant-select-selector:hover,
    .ant-select-selector:focus {
        border-color: ${CssColors.black} !important;
    }

    .ant-select-focused:not(.ant-select-disabled).ant-select:not(
            .ant-select-customize-input
        )
        .ant-select-selector {
        box-shadow: 0 0 0 2px rgba(29, 29, 31, 0.2) !important;
        border-color: ${CssColors.black} !important;
    }
`;
